import { useCallback } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';

export const useSetupEntryPath = (): ((jobArchitectureId: string) => string) => {
    const {
        applicationState: { featureFlagService },
    } = useApplicationContext();

    return useCallback(
        (jobArchitectureId: string) =>
            featureFlagService.isFeatureFlagEnabled('installation-guide')
                ? `/installation-guide/${jobArchitectureId}`
                : `/job-architecture-v2/${jobArchitectureId}/setup-dialog/overview`,
        [featureFlagService],
    );
};
